import React from 'react';
import CouponPreview from '../../common/CouponPreview';
import CouponProductLinkInfo from '../../common/CouponProductLinkInfo';

const CouponSaveProductLinkInfo = (props) => {
  const {
    couponProductLinkInfo,
    mainProductCategorySelectList,
    subProductCategorySelectList,
    getCouponProductItemList,
    getCouponProductItemListExcelDownload,
    selectCouponProductItemList,
    getSelectedCouponProductItemListExcelDownload,
    checkValidCouponProductItemListExcelUpload,
    couponInfo,
    getProductSubCategoryList,
  } = props;

  return (
    <div className="coupon-save-product-link-info">
      {/*쿠폰 미리보기*/}
      <CouponPreview couponInfo={couponInfo} />

      {/*쿠폰 사용 가능한 상품*/}
      <CouponProductLinkInfo
        couponProductLinkInfo={couponProductLinkInfo}
        mainProductCategorySelectList={mainProductCategorySelectList}
        subProductCategorySelectList={subProductCategorySelectList}
        getCouponProductItemList={getCouponProductItemList}
        getCouponProductItemListExcelDownload={getCouponProductItemListExcelDownload}
        selectCouponProductItemList={selectCouponProductItemList}
        getSelectedCouponProductItemListExcelDownload={getSelectedCouponProductItemListExcelDownload}
        checkValidCouponProductItemListExcelUpload={checkValidCouponProductItemListExcelUpload}
        getProductSubCategoryList={getProductSubCategoryList}
        discountType={couponInfo.discountType}
        discountAmount={couponInfo.discountAmount}
        minimumPurchasePrice={couponInfo.minimumPurchasePrice}
        maxDiscountPrice={couponInfo.maxDiscountPrice}
      />
    </div>
  );
};

export default CouponSaveProductLinkInfo;
